/**
 * Shared react-select props to render the menu in a body portal above modals/drawers.
 *
 * react-select renders its menu inline by default, so inside a Modal/Drawer (which clip
 * content with `overflow: auto` and sit at very high z-index) the menu gets cut off or
 * hidden. Spreading `{...menuPortalProps}` on any Select/AsyncSelect fixes it everywhere.
 *
 * Modal dialog z-index in this app is ~100000, Drawer ~1200 — the portal uses 100100 to win.
 *
 * The menu is portalled to <body>, so it does NOT inherit the form's `text-sm`;
 * we pin every part to 14px so control + options match the surrounding fields.
 */
const FONT = '14px';

export const menuPortalProps = {
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  menuPosition: 'fixed',
  styles: {
    menuPortal: (base) => ({ ...base, zIndex: 100100, fontSize: FONT }),
    menu: (base) => ({ ...base, fontSize: FONT }),
    option: (base) => ({ ...base, fontSize: FONT }),
    control: (base) => ({ ...base, fontSize: FONT }),
    singleValue: (base) => ({ ...base, fontSize: FONT }),
    multiValueLabel: (base) => ({ ...base, fontSize: FONT }),
    input: (base) => ({ ...base, fontSize: FONT }),
    placeholder: (base) => ({ ...base, fontSize: FONT }),
  },
};

export default menuPortalProps;
